import React, { Component } from 'react';
import { GET_LIST, GET_ONE, Responsive, withDataProvider } from 'react-admin';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import Welcome from './Welcome';
import WssMap from './WssMap';
import Alerts from './AlertsNG';
import Devices from './Devices';

const styles = {
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginBottom: '2em' },
};

class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {selectedDevice: ''};
        this.handleSelectDevice = this.handleSelectDevice.bind(this);
    }

    handleSelectDevice(deviceId) {
        if (this.state.selectedDevice === deviceId) {
            deviceId = '';
        }
        this.setState({
            selectedDevice: deviceId,
        }, () => {this.fetchAlerts()});
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        // handle refresh
        if (this.props.version !== prevProps.version) {
            this.fetchData();
        }
    }

    fetchData() {
        this.fetchAlerts();
        this.fetchDevices();
    }

    async fetchAlerts() {
        const { dataProvider } = this.props;
        const { data: alerts } = await dataProvider(GET_LIST, 'alerts', {
            pagination: { page: 1, perPage: 150 },
            sort: {},
        });
        const deviceAlerts = this.state.selectedDevice ? alerts.filter(alert => alert.device === this.state.selectedDevice) : alerts;
        const nbAlerts = deviceAlerts.reduce(nb => ++nb, 0);
        const alertList = deviceAlerts.slice(0, Math.min(50, alerts.length));
        this.setState({ alertList, nbAlerts });
    }

    async fetchDevices() {
        const { dataProvider } = this.props;
        const { data: devices } = await dataProvider(GET_LIST, 'devices', {
            pagination: { page: 1, perPage: 150 },
            sort: {},
        });

        const nbDevices = devices.reduce(nb => ++nb, 0);

        const nbOffline = devices.reduce((acc, item) => {
            const now = new Date().getTime();
            const time = new Date(item.time);
            if (now - time.getTime() > 180000)
                ++acc;
            return acc;
        }, 0);

        const nbOnline = nbDevices - nbOffline;

        const nbTroubled = devices.reduce((acc, item) => {
            const now = new Date().getTime();
            const time = new Date(item.time);
            if (item.service && (now - time.getTime() > 180000))
                ++acc;
            return acc;
        }, 0);

        const counts = {nbDevices, nbOnline, nbOffline, nbTroubled};

        const deviceList = devices.slice(0, Math.min(50, devices.length));
        this.setState({ deviceList, counts });
    }

    render() {
        const {
            alertList,
            nbAlerts,
            deviceList,
            counts,
            selectedDevice,
        } = this.state;
        return (
            <Responsive
                xsmall={
                    <div>
                        <div style={styles.flexColumn}>
                            <div style={{ marginBottom: '2em' }}>
                                <Welcome />
                            </div>
                        </div>
                    </div>
                }
                small={
                    <div style={styles.flexColumn}>
                        <div style={styles.leftCol}>
                            <Welcome />
                        </div>
                    </div>
                }
                medium={
                    <div style={styles.flex}>
                        <div style={styles.leftCol}>
                            <div style={styles.singleCol}>
                                <Devices counts={counts} devices={deviceList}
                                         selectedDevice={selectedDevice}
                                         onSelectDeviceChange={this.handleSelectDevice}
                                />
                            </div>
                            <div style={styles.singleCol}>
                                <Alerts nb={nbAlerts} alerts={alertList} selectedDevice={selectedDevice} />
                            </div>
                        </div>
                        <div style={styles.rightCol}>
                            <WssMap selectedDevice={selectedDevice} />
                        </div>
                    </div>
                }
            />
        );
    }
}

const mapStateToProps = state => ({
    version: state.admin.ui.viewVersion,
});

export default compose(
    connect(mapStateToProps),
    withDataProvider
)(Dashboard);
